import classNames from "classnames";
import ActivityPreviewLink from "PFApp/components/activity_commons/activity_preview_link";
import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { getProfileName } from "PFCore/helpers/profile";
import { Activity } from "PFTypes";

import css from "./content.module.scss";
import { Description } from "./description";

export type QuestionSuggestionContentProps = {
  task: Activity;
  type?: string;
};

export const QuestionSuggestionContent = ({ task, type }: QuestionSuggestionContentProps) => {
  const { profile } = task;

  return (
    <div className={css.wrapper}>
      <ActivityPreviewLink activity={task} profile={profile}>
        <div className={css.column}>
          <div className={css.row}>
            <ProfileAvatar profile={profile} size={50} />
            <div className={css.name}>
              <span>{getProfileName(profile)}</span>
              <span>{type === "question" ? " asks..." : " suggests..."}</span>
            </div>
          </div>
          <div
            className={classNames(css.bubble, {
              [css.bubbleSuggestion]: type === "suggestion"
            })}
          >
            <b>{task.name}</b>
            <Description description={task.description} />
          </div>
        </div>
      </ActivityPreviewLink>
    </div>
  );
};
